<template>
  <b-card v-if="!!option" id="page-agenda-partial-form" no-body class="mb-0">
    <b-card-header>
      <b-card-title
        ><h2>
          {{ $t(getTitle()) }}
          {{ $t("pages.agendaPartial.title").toLowerCase() }}
        </h2></b-card-title
      >
      <b-button variant="primary" @click="goBack">
        <feather-icon icon="ArrowLeftIcon" />
        {{ $t("back") }}
      </b-button>
    </b-card-header>

    <b-card-body>
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <b-col cols="12" md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('customer'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('customer'))"
                  label-for="idClient"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="idClient"
                    ref="clientSelect"
                    v-model="agendaPartial.idClient"
                    :options="listCustomers"
                    label="name"
                    :placeholder="$t(label('customer'))"
                    :disabled="!isSaveMode"
                    :filterable="false"
                    @search="searchClientsAll"
                    @open="onOpenClients"
                    :reduce="(option) => option.idClient"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPageClients"
                        ref="loadClients"
                        class="loader"
                      >
                        Cargando más opciones...
                      </li>
                    </template>
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!--  Stores -->
            <b-col cols="12" md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('employee'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('employee'))"
                  label-for="idEmployee"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    ref="employeeSelect"
                    input-id="idEmployee"
                    v-model="agendaPartial.idEmployee"
                    :options="listEmployees"
                    label="name"
                    :placeholder="$t(label('employee'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.idEmployee"
                    :filterable="false"
                    @search="searchEmployeesAll"
                    @open="onOpenEmployees"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPageEmployees"
                        ref="loadEmployees"
                        class="loader"
                      >
                        Cargando más opciones...
                      </li>
                    </template>
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!-- service -->
            <b-col cols="12" md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('service'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('service'))"
                  label-for="idService"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    ref="serviceSelect"
                    input-id="idService"
                    v-model="agendaPartial.idService"
                    :options="listServices"
                    label="name"
                    :placeholder="$t(label('service'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.idService"
                    :filterable="false"
                    @search="searchServicesAll"
                    @open="onOpenServices"
                  >
                    <template #list-footer>
                      <li
                        v-show="hasNextPageServices"
                        ref="loadServices"
                        class="loader"
                      >
                        Cargando más opciones...
                      </li>
                    </template>
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group
                :label="$t(label('date'))"
                label-for="appointmentDate"
              >
                <validation-provider
                  #default="{ errors }"
                  :name="$t(label('date'))"
                >
                  <b-form-datepicker
                    id="appointmentDate"
                    ref="appointmentDate"
                    v-model="agendaPartial.appointmentDate"
                    :placeholder="$t(label('date'))"
                    :state="errors.length > 0 ? false : null"
                    :disabled="!isSaveMode"
                    class="mr-2"
                    reset-button
                    dropright
                    :min="new Date()"
                  >
                  </b-form-datepicker>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
            <!-- status -->
            <b-col cols="12" md="6">
              <validation-provider
                #default="{ errors }"
                :name="$t(label('status'))"
                rules="required"
              >
                <b-form-group
                  :label="$t(label('status'))"
                  label-for="idCatStatus"
                  :state="errors.length > 0 ? false : null"
                >
                  <v-select
                    input-id="idCatStatus"
                    v-model="agendaPartial.idCatStatus"
                    :options="listStatus"
                    label="label"
                    :placeholder="$t(label('status'))"
                    :disabled="!isSaveMode"
                    :reduce="(option) => option.value"
                  >
                    <span slot="no-options">{{ $t("sorryOption") }}</span>
                  </v-select>
                  <b-form-invalid-feedback
                    :state="errors.length > 0 ? false : null"
                  >
                    {{ errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </b-col>

            <!--  notes -->
            <b-col cols="12" md="6">
              <b-form-group :label="$t(label('notes'))" label-for="direccion">
                <b-form-textarea
                  id="direccion"
                  v-model="agendaPartial.notes"
                  :placeholder="$t(label('notes'))"
                  :disabled="!isSaveMode"
                  rows="6"
                />
              </b-form-group>
            </b-col>
            <b-col
              class="d-flex justify-content-end align-items-center"
              cols="12"
            >
              <b-button
                v-if="option != 2"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                type="submit"
                variant="primary"
                class="mr-1"
                @click.prevent="onSubmit"
              >
                {{ $t("save") }}
              </b-button>
              <b-button
                v-if="option == 1"
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="reset"
                variant="outline-secondary"
                @click="onCancel"
              >
                {{ $t("cancel") }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card-body>
  </b-card>
</template>

<script>
import _ from "lodash";
import {
  ValidationProvider,
  ValidationObserver,
  localize,
  extend,
} from "vee-validate";
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BForm,
  BFormTextarea,
  BAlert,
  BFormInvalidFeedback,
  BFormGroup,
  BFormDatepicker,
} from "bootstrap-vue";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import { required } from "@validations";
import { showLoading, stopLoading, getParams } from "@core/utils/utils";
import vSelect from "vue-select";
import { VueTelInput } from "vue-tel-input";
import "vue-tel-input/dist/vue-tel-input.css";

import { allServices, getService } from "@core/api/request/services";
import {
  allEmployeesByCompany,
  getEmployee,
} from "@core/api/request/employees";
import {
  allClientsByCompany,
  getClient,
} from "@core/api/request/clients";
import {
  createOrEditAgendaPartial,
  getAgendaPartial,
} from "@core/api/request/partialAgenda";
import { getCatalog } from "@core/api/request/catalogs";

const agendaPartial = {
  guidCompany: null,
  idClient: null,
  idEmployee: null,
  idService: null,
  notes: "",
  idAgendaPartial: null,
  idCatStatus: null,
  urlWhatsApp: "",
  appointmentDate: null,
};

export default {
  components: {
    BAlert,
    ValidationProvider,
    ValidationObserver,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BForm,
    BFormTextarea,
    BFormInvalidFeedback,
    BFormGroup,
    vSelect,
    VueTelInput,
    BFormDatepicker,
  },
  directives: {
    Ripple,
  },
  data: () => ({
    model: "agendaPartial",
    loading: false,
    isSaveMode: true,
    required,
    option: "",
    agendaPartial: Object.assign(agendaPartial),
    listCustomers: [],
    listServices: [],
    listEmployees: [],
    listStatus: [],
    companyGuid: null,

    currentPageClients: 1,
    perPageClients: 20,
    totalPagesClients: 0,
    searchClients: null,
    loadingClients: false,
    hasNextPageClients: true,
    currentPageServices: 1,
    perPageServices: 20,
    totalPagesServices: 0,
    searchServices: null,
    loadingServices: false,
    hasNextPageServices: true,
    currentPageEmployees: 1,
    perPageEmployees: 20,
    totalPagesEmployees: 0,
    searchEmployees: null,
    loadingEmployees: false,
    hasNextPageEmployees: true,
  }),

  computed: {},

  created() {
    localize("es");
    this.initialize();
  },

  beforeDestroy() {
    if (this.observerClients) this.observerClients.disconnect();
    if (this.observerServices) this.observerServices.disconnect();
    if (this.observerEmployees) this.observerEmployees.disconnect();
  },

  watch: {
    "$store.state.appConfig.activeCompanyGuid"(guid) {
      this.companyGuid = guid;
      this.resetRemoteSelects();
      this.listCustomers = [];
      this.listServices = [];
      this.listEmployees = [];
      this.loadData();
    },
  },

  mounted() {
    this.observerClients = new IntersectionObserver(this.infiniteScrollClients);
    this.observerServices = new IntersectionObserver(
      this.infiniteScrollServices,
    );
    this.observerEmployees = new IntersectionObserver(
      this.infiniteScrollEmployees,
    );
  },

  methods: {
    label(field) {
      return `pages.agendaPartial.form.label.${field}`;
    },

    labelHeader(field) {
      return `pages.agendaPartial.table.tableHeader.${field}`;
    },

    getTitle() {
      if (this.option === 1) return "register";
      else if (this.option === 2) return "show";
      else if (this.option === 3) return "edit";
    },

    async initialize() {
      this.option = this.$route.params.option;

      if (this.option === undefined) {
        router.push({ name: "agendaPartial" }).catch(() => {});
      }

      this.companyGuid = this.$store.state.appConfig.activeCompanyGuid;
      switch (this.option) {
        case 1:
          this.onCancel();
          this.loadData();
          break;
        case 2:
        case 3:
          if (this.$route.params.idAgendaPartial === undefined) {
            router.push({ name: "agendaPartial" }).catch(() => {});
          }
          this.isSaveMode = this.option !== 2;
          await this.loadData();
          await this.showAgendaPartial(this.$route.params.idAgendaPartial);
          break;
      }
    },

    onSubmit() {
      try {
        this.$refs.simpleRules.validate().then((success) => {
          if (success) {
            showLoading();

            const body = {
              guidCompany: this.agendaPartial.companyGuid || this.companyGuid,
              idClient: this.agendaPartial.idClient,
              idEmployee: this.agendaPartial.idEmployee,
              idService: this.agendaPartial.idService,
              notes: this.agendaPartial.notes,
              idCatStatus: this.agendaPartial.idCatStatus || null,
              urlWhatsApp: this.agendaPartial.urlWhatsApp || "",
              idAgendaPartial: this.agendaPartial.idAgendaPartial || null,
              appointmentDate: this.agendaPartial.appointmentDate,
            };

            const id =
              this.option === 1 ? null : this.agendaPartial.idAgendaPartial;
            createOrEditAgendaPartial(body, id)
              .then(() => {
                this.alertToast(
                  "success",
                  this.$t("Alert"),
                  `${
                    this.option != 3
                      ? this.$t("registerSuccess")
                      : this.$t("updateRecord")
                  }`,
                  "CheckIcon",
                );
                this.goBack();
                stopLoading();
              })
              .catch((error) => {
                console.error("Error loading data", error.message);
                stopLoading();
                this.alertToast(
                  "danger",
                  this.$t("Alert"),
                  error.message,
                  "AlertTriangleIcon",
                );
              });
          }
        });
      } catch (error) {
        console.error("Error loading data", error.message);
        this.alertToast("danger", "Error", error.message, "AlertTriangleIcon");
      }
    },
    async loadData() {
      try {
        showLoading();
        // // SERVICIOS
        // const arrParamServices = getParams([
        //   `page,1`,
        //   `rows,999`,
        //   `active,${true}`,
        //   `guidCompany,${this.companyGuid}`,
        // ]);
        // // CUSTOMERS
        // const arrParamCustomers = getParams([
        //   `page,1`,
        //   `rows,10000`,
        //   `active,${true}`,
        //   `guidCompany,${this.companyGuid}`,
        // ]);
        // // EMPLOYEES
        // const arrParamEmployees = getParams([
        //   `page,1`,
        //   `rows,999`,
        //   `active,${true}`,
        //   `guidCompany,${this.companyGuid}`,
        // ]);

        // "itemsPage,1",
        // "itemsRows,999",
        // "guidCatalog,a5426eaf-8a96-42a2-a2b5-775fbc38fe09",
        // AGENDA_PARCIAL_STATUS
        const arrParamStatus = getParams([
          `itemsPage,1`,
          `itemsRows,999`,
          "guidCatalog,8b8dd8dc-9665-4483-9609-6e9d1218f5ea",
        ]);

        const [statusResp] = await Promise.all([getCatalog(arrParamStatus)]);

        await Promise.all([
          this.loadClientsByCompanie(),
          this.loadServicesByCompanie(),
          this.loadEmployeeByCompanie(),
        ]);

        const statusData = _.get(statusResp, "data.listOfItems.items") || [];
        this.listStatus = statusData.map((item) => ({
          label: item.name,
          value: item.id,
        }));
      } catch (error) {
        console.error("Error loading data", error);
        this.alertToast(
          "danger",
          this.$t("Alert"),
          error.message,
          "AlertTriangleIcon",
        );
      } finally {
        stopLoading();
      }
    },

    async showAgendaPartial(id) {
      try {
        const resp = await getAgendaPartial(id);
        const agendaPartial = _.get(resp, "data");
        if (!agendaPartial) return;

        await this.ensureAgendaPartialSelectOptions(agendaPartial);

        this.agendaPartial = Object.assign(this.agendaPartial, {
          idAgendaPartial: agendaPartial.idAgendaPartial,
          idClient: agendaPartial.idClient || null,
          idEmployee: agendaPartial.idEmployee || null,
          idService: agendaPartial.idService || null,
          notes: agendaPartial.notes || "",
          idCatStatus: agendaPartial.idCatStatus || null,
          urlWhatsApp: agendaPartial.urlWhatsApp || "",
          guidCompany: agendaPartial.guidCompany || null,
          appointmentDate: agendaPartial.appointmentDate || null,
        });
      } catch (error) {
        console.log("error", error);
        this.alertToast(
          "danger",
          this.$t("Alert"),
          error.message,
          "AlertTriangleIcon",
        );
      }
    },

    sameIdentifier(firstValue, secondValue) {
      if (firstValue == null || secondValue == null) {
        return firstValue === secondValue;
      }
      return String(firstValue).trim() === String(secondValue).trim();
    },

    ensureClientOption(client) {
      if (client?.idClient == null) return null;

      const currentOption = this.listCustomers.find((item) =>
        this.sameIdentifier(item.idClient, client.idClient),
      );
      const optionData = {
        idClient: client.idClient,
        name:
          `${client.name || ""} ${client.lastName || ""}`.trim() ||
          client.nameClient ||
          String(client.idClient),
      };

      if (currentOption) {
        Object.assign(currentOption, optionData);
        return currentOption;
      }

      const option = optionData;
      this.listCustomers.push(option);
      return option;
    },

    ensureEmployeeOption(employee) {
      if (employee?.idEmployee == null) return null;

      const currentOption = this.listEmployees.find((item) =>
        this.sameIdentifier(item.idEmployee, employee.idEmployee),
      );
      const optionData = {
        idEmployee: employee.idEmployee,
        name:
          employee.name ||
          employee.nameEmployee ||
          String(employee.idEmployee),
      };

      if (currentOption) {
        Object.assign(currentOption, optionData);
        return currentOption;
      }

      const option = optionData;
      this.listEmployees.push(option);
      return option;
    },

    ensureServiceOption(service) {
      if (service?.idService == null) return null;

      const currentOption = this.listServices.find((item) =>
        this.sameIdentifier(item.idService, service.idService),
      );
      const optionData = {
        ...service,
        idService: service.idService,
        name:
          service.name || service.nameService || String(service.idService),
      };

      if (currentOption) {
        Object.assign(currentOption, optionData);
        return currentOption;
      }

      const option = optionData;
      this.listServices.push(option);
      return option;
    },

    async ensureAgendaPartialSelectOptions(agendaPartialData) {
      const requests = [];

      if (agendaPartialData.idClient != null) {
        const clientData = {
          ...(agendaPartialData.client || {}),
          idClient: agendaPartialData.idClient,
          nameClient:
            agendaPartialData.nameClient || agendaPartialData.clientName,
        };

        if (
          clientData.name ||
          clientData.lastName ||
          clientData.nameClient
        ) {
          this.ensureClientOption(clientData);
        } else {
          requests.push(
            getClient(agendaPartialData.idClient)
              .then((response) => {
                const client = _.get(response, "data");
                if (client) this.ensureClientOption(client);
              })
              .catch((error) => {
                console.error(
                  "Error loading agenda partial client:",
                  error.message,
                );
              }),
          );
        }
      }

      if (agendaPartialData.idEmployee != null) {
        const employeeData = {
          ...(agendaPartialData.employee || {}),
          idEmployee: agendaPartialData.idEmployee,
          nameEmployee:
            agendaPartialData.nameEmployee || agendaPartialData.employeeName,
        };

        if (employeeData.name || employeeData.nameEmployee) {
          this.ensureEmployeeOption(employeeData);
        } else {
          requests.push(
            getEmployee(agendaPartialData.idEmployee)
              .then((response) => {
                const employee = _.get(response, "data");
                if (employee) this.ensureEmployeeOption(employee);
              })
              .catch((error) => {
                console.error(
                  "Error loading agenda partial employee:",
                  error.message,
                );
              }),
          );
        }
      }

      if (agendaPartialData.idService != null) {
        const serviceData = {
          ...(agendaPartialData.service || {}),
          idService: agendaPartialData.idService,
          nameService:
            agendaPartialData.nameService || agendaPartialData.serviceName,
        };

        if (serviceData.name || serviceData.nameService) {
          this.ensureServiceOption(serviceData);
        } else {
          const serviceGuid =
            agendaPartialData.guidService || serviceData.guid || null;
          if (serviceGuid) {
            requests.push(
              getService(serviceGuid)
                .then((response) => {
                  const service = _.get(response, "data");
                  if (service) {
                    this.ensureServiceOption({
                      ...service,
                      idService: agendaPartialData.idService,
                    });
                  }
                })
                .catch((error) => {
                  console.error(
                    "Error loading agenda partial service:",
                    error.message,
                  );
                }),
            );
          } else {
            this.ensureServiceOption(serviceData);
          }
        }
      }

      await Promise.all(requests);
    },

    resetRemoteSelects() {
      this.currentPageClients = 1;
      this.totalPagesClients = 0;
      this.searchClients = null;
      this.loadingClients = false;
      this.hasNextPageClients = true;

      this.currentPageServices = 1;
      this.totalPagesServices = 0;
      this.searchServices = null;
      this.loadingServices = false;
      this.hasNextPageServices = true;

      this.currentPageEmployees = 1;
      this.totalPagesEmployees = 0;
      this.searchEmployees = null;
      this.loadingEmployees = false;
      this.hasNextPageEmployees = true;
    },

    chargeParamsClients() {
      const arrParams = [
        `page,${this.currentPageClients}`,
        `rows,${this.perPageClients}`,
        `active,${true}`,
        `guidCompany,${this.companyGuid}`,
      ];

      if (this.searchClients) {
        arrParams.push(`name,${this.searchClients}`);
      }

      return getParams(arrParams);
    },

    async loadClientsByCompanie() {
      if (
        !this.companyGuid ||
        this.loadingClients ||
        !this.hasNextPageClients
      ) {
        return;
      }

      this.loadingClients = true;
      try {
        const arrParams = this.chargeParamsClients();
        const resp = await allClientsByCompany(arrParams);
        const data = _.get(resp, "data");
        const items = Array.isArray(data?.items) ? data.items : [];

        const mapped = items.map((item) => ({
          name: `${item.name} ${item.lastName || ""}`.trim(),
          idClient: item.idClient,
        }));

        const merged = [...this.listCustomers, ...mapped];

        this.listCustomers = merged.filter(
          (item, index, self) =>
            index ===
            self.findIndex((x) =>
              this.sameIdentifier(x.idClient, item.idClient),
            ),
        );

        this.currentPageClients = data?.currentPage || this.currentPageClients;
        this.totalPagesClients = data?.totalPages || 0;
        this.hasNextPageClients =
          this.currentPageClients < this.totalPagesClients;
      } catch (error) {
        this.hasNextPageClients = false;
        this.alertToast(
          "danger",
          this.$t("Alert"),
          error.message,
          "AlertTriangleIcon",
        );
      } finally {
        this.loadingClients = false;
      }
    },

    async onOpenClients() {
      if (this.hasNextPageClients) {
        await this.$nextTick();
        if (this.$refs.loadClients) {
          this.observerClients.observe(this.$refs.loadClients);
        }
      }
    },

    searchClientsAll(value) {
      const selectedOption = this.listCustomers.find((item) =>
        this.sameIdentifier(item.idClient, this.agendaPartial.idClient),
      );
      this.searchClients = value;
      this.listCustomers = selectedOption ? [selectedOption] : [];
      this.currentPageClients = 1;
      this.totalPagesClients = 0;
      this.hasNextPageClients = true;
      this.loadClientsByCompanie();
    },

    async infiniteScrollClients(entries) {
      const entry = entries[0];

      if (
        entry?.isIntersecting &&
        this.hasNextPageClients &&
        !this.loadingClients
      ) {
        this.currentPageClients += 1;
        await this.loadClientsByCompanie();
      }
    },

    chargeParamsServices() {
      const arrParams = [
        `page,${this.currentPageServices}`,
        `rows,${this.perPageServices}`,
        `active,${true}`,
        `guidCompany,${this.companyGuid}`,
      ];

      if (this.searchServices) {
        arrParams.push(`name,${this.searchServices}`);
      }

      return getParams(arrParams);
    },

    async loadServicesByCompanie() {
      if (
        !this.companyGuid ||
        this.loadingServices ||
        !this.hasNextPageServices
      ) {
        return;
      }

      this.loadingServices = true;
      try {
        const resp = await allServices(this.chargeParamsServices());
        const data = _.get(resp, "data");
        const items = Array.isArray(data?.items) ? data.items : [];

        const merged = [...this.listServices, ...items];

        this.listServices = merged.filter(
          (item, index, self) =>
            index ===
            self.findIndex((x) =>
              this.sameIdentifier(x.idService, item.idService),
            ),
        );
        this.currentPageServices =
          data?.currentPage || this.currentPageServices;
        this.totalPagesServices = data?.totalPages || 0;
        this.hasNextPageServices =
          this.currentPageServices < this.totalPagesServices;
      } catch (error) {
        this.hasNextPageServices = false;
        this.alertToast(
          "danger",
          this.$t("Alert"),
          error.message,
          "AlertTriangleIcon",
        );
      } finally {
        this.loadingServices = false;
      }
    },

    async onOpenServices() {
      if (this.hasNextPageServices) {
        await this.$nextTick();
        if (this.$refs.loadServices) {
          this.observerServices.observe(this.$refs.loadServices);
        }
      }
    },

    searchServicesAll(value) {
      const selectedOption = this.listServices.find((item) =>
        this.sameIdentifier(item.idService, this.agendaPartial.idService),
      );
      this.searchServices = value;
      this.listServices = selectedOption ? [selectedOption] : [];
      this.currentPageServices = 1;
      this.totalPagesServices = 0;
      this.hasNextPageServices = true;
      this.loadServicesByCompanie();
    },

    async infiniteScrollServices(entries) {
      const entry = entries[0];

      if (
        entry?.isIntersecting &&
        this.hasNextPageServices &&
        !this.loadingServices
      ) {
        this.currentPageServices += 1;
        await this.loadServicesByCompanie();
      }
    },

    chargeParamsEmployees() {
      const arrParams = [
        `page,${this.currentPageEmployees}`,
        `rows,${this.perPageEmployees}`,
        `active,${true}`,
        `guidCompany,${this.companyGuid}`,
      ];

      if (this.searchEmployees) {
        arrParams.push(`name,${this.searchEmployees}`);
      }

      return getParams(arrParams);
    },

    async loadEmployeeByCompanie() {
      if (
        !this.companyGuid ||
        this.loadingEmployees ||
        !this.hasNextPageEmployees
      ) {
        return;
      }

      this.loadingEmployees = true;
      try {
        const resp = await allEmployeesByCompany(this.chargeParamsEmployees());
        const data = _.get(resp, "data");
        const items = Array.isArray(data?.items) ? data.items : [];

        const mapped = items.map((item) => ({
          name: `${item.name || ""}`.trim(),
          idEmployee: item.idEmployee,
        }));

        const merged = [...this.listEmployees, ...mapped];

        this.listEmployees = merged.filter(
          (item, index, self) =>
            index ===
            self.findIndex((x) =>
              this.sameIdentifier(x.idEmployee, item.idEmployee),
            ),
        );
        this.currentPageEmployees =
          data?.currentPage || this.currentPageEmployees;
        this.totalPagesEmployees = data?.totalPages || 0;
        this.hasNextPageEmployees =
          this.currentPageEmployees < this.totalPagesEmployees;
      } catch (error) {
        this.hasNextPageEmployees = false;
        this.alertToast(
          "danger",
          this.$t("Alert"),
          error.message,
          "AlertTriangleIcon",
        );
      } finally {
        this.loadingEmployees = false;
      }
    },

    async onOpenEmployees() {
      if (this.hasNextPageEmployees) {
        await this.$nextTick();
        if (this.$refs.loadEmployees) {
          this.observerEmployees.observe(this.$refs.loadEmployees);
        }
      }
    },

    searchEmployeesAll(value) {
      const selectedOption = this.listEmployees.find((item) =>
        this.sameIdentifier(item.idEmployee, this.agendaPartial.idEmployee),
      );
      this.searchEmployees = value;
      this.listEmployees = selectedOption ? [selectedOption] : [];
      this.currentPageEmployees = 1;
      this.totalPagesEmployees = 0;
      this.hasNextPageEmployees = true;
      this.loadEmployeeByCompanie();
    },

    async infiniteScrollEmployees(entries) {
      const entry = entries[0];

      if (
        entry?.isIntersecting &&
        this.hasNextPageEmployees &&
        !this.loadingEmployees
      ) {
        this.currentPageEmployees += 1;
        await this.loadEmployeeByCompanie();
      }
    },

    goBack() {
      this.$refs.simpleRules.reset();
      router.back();
    },

    onCancel() {
      Object.assign(this.agendaPartial, {
        guidCompany: null,
        idClient: null,
        idEmployee: null,
        idService: null,
        notes: "",
        idAgendaPartial: null,
        idCatStatus: null,
        urlWhatsApp: "",
        appointmentDate: null,
      });

      this.listCustomers = [];
      this.listServices = [];
      this.listEmployees = [];
    },

    message(title, text, icon) {
      this.$swal({
        title,
        text,
        icon,
        customClass: {
          confirmButton: "btn btn-success",
        },
      });
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "../../../../public/loader.css";
@import "~@core/scss/vue/libs/vue-wizard.scss";
</style>
